(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('MigrateProjectAssignedData', MigrateProjectAssignedData);

    MigrateProjectAssignedData.$inject = ['$resource'];

    function MigrateProjectAssignedData ($resource) {
        var resourceUrl =  '/api/migrateProjectAssignedData';
        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
